// PRODUCT GALLERY -- START
$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: false,
    dots: false,
    draggable: true,
    focusOnSelect: false,
});

$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M22.5 27L13.5 18L22.5 9" stroke="#124734" stroke-width="2.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M13.5 27L22.5 18L13.5 9" stroke="#124734" stroke-width="2.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
});

jQuery(document).on("click",".zoom-gallery",function(){
  jQuery('body').addClass("product-popup-open");
  jQuery('.product-media-modal').attr('open','');
});

jQuery(document).on("click",".product-media-modal__toggle",function(){
  jQuery('body').removeClass("product-popup-open");
});

jQuery(document).on("click",".hchoose-modal-button",function(){  
  jQuery('.hchoose-modal').addClass('js-modal-open');
});

jQuery(document).on('click',".hchoose-close",function(){
   jQuery('.hchoose-modal').removeClass('js-modal-open');
});
// PRODUCT GALLERY -- END

// PRODUCT STICKY BAR -- START
if(jQuery('.product_buybutton_block').length!=0){
  jQuery(window).scroll(function(){
    var buttonHeight = parseInt(jQuery('.product_buybutton_block').offset().top);
    var compareSectionTop = parseInt(jQuery('.faq_section').offset().top);
    if (jQuery(this).scrollTop() > buttonHeight && jQuery(this).scrollTop() < compareSectionTop) {
        jQuery('.sticky_product_bar').show();
    }else{
        jQuery('.sticky_product_bar').hide();
    }
  });
}
// PRODUCT STICKY BAR -- END

// START :: CART PROGRESS
var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');

// Function to update cart progress
function updateCartProgress() {
  // Only fetch if cart drawer is open or cart progress element exists and is visible
  if(jQuery('.drawer.active').length === 0 && !jQuery('.cc-cart-progress:visible').length) {
    return;
  }

  jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if (cart.items.length === 1) {
        var quantity = cartData[0].quantity;
        var product_handle = cartData[0].handle;
        var variantTitle = cartData[0].variant_title;
        var lineItemKey = cartData[0].key;
        var productId = cartData[0].product_id;
        if(cartData[0].selling_plan_allocation!=undefined){
          jQuery('.cart-drawer').find('.Subscription-container').hide();
        }
        if(quantity==1){
          fetch('/products/' + product_handle + '.js')
            .then(response => response.json())
            .then(data => {
              if(data.selling_plan_groups.length>0){
                if(jQuery('.Subscription-container').find('#upgrade_subscription').is(":checked") && cartData[0].selling_plan_allocation==undefined){
                  if(variantTitle!="" && variantTitle!=undefined){
                    variantTitle = variantTitle.toLowerCase();
                    var subscriptionTitle = '1 month';
                    if(variantTitle!='default title'){
                      if(variantTitle=='2-pack'){
                        subscriptionTitle = '2 month';
                      }else if(variantTitle=='3-pack'){
                        subscriptionTitle = '3 month';
                      }else if(variantTitle=='4-pack'){
                        subscriptionTitle = '4 month';
                      }
                    }
                    for (let r = 0; r < data.selling_plan_groups.length; r++) {
                      var planName = data.selling_plan_groups[r].name;
                      if (planName.indexOf(subscriptionTitle) !== -1) {
                        var planId = data.selling_plan_groups[r].selling_plans[0].id;
                        cartUpdateData(lineItemKey,planId);
                      }
                    }
                }
              }
            }else{
              jQuery('.cart-drawer').find('.Subscription-container').hide();
            }
          });
        }
      }else if(cart.items.length>1){
        jQuery('.cart-drawer').find('.Subscription-container').hide();
      }

      if(cartData.length>0){
        for(var k=0;k<cartData.length;k++){
          var productId = cartData[k].product_id;
          if(jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').length>0){
            jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').hide();
          }
          //console.log("productId",productId);
          if(jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productId+'"]').length>0){
            jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productId+'"]').hide();
          }
        }
        if(jQuery('.drawer.active').length>0){
          subTotal = cart.original_total_price;
          var percentage_reached = (eval(subTotal) / eval(goalAmount));
          if(parseFloat(percentage_reached) > 100){
            var percentage_reached = 100;
          }
          jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
          jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
        
          jQuery('.cc-cart-progressbar').removeClass("progress-filled");
          jQuery('.cart_shipping_box').hide();
          if(percentage_reached == 100){
            jQuery('.cart_shipping_box').show();
            jQuery('.cc-cart-progressbar').addClass("progress-filled");
          }else{
            jQuery('.cart_shipping_box').hide();
          }
          
        
          var cartTotalFull = eval(subTotal) / 100;
          var tempStr = '';
          var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
          if(goalAmount > cartTotalFull){
            var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
            tempStr += goalBeforeText;
            tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
            tempStr += Shopify.formatMoney(goalPendingAmount);
            tempStr += '</span>'
            tempStr += goalAfterText;
          }
          else{
            tempStr += goalReachText;
            svg = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none"><path d="M10.5625 17.2493V10.7507L4.875 7.45763V13.6533C4.875 13.7431 4.89746 13.8273 4.94238 13.9057C4.98715 13.9843 5.05445 14.0516 5.14428 14.1076L10.5625 17.2493ZM11.4375 17.2493L16.8557 14.1076C16.9456 14.0516 17.0129 13.9843 17.0576 13.9057C17.1025 13.8273 17.125 13.7431 17.125 13.6533V7.45763L11.4375 10.7507V17.2493ZM10.2932 18.1007L4.70678 14.8818C4.4857 14.7551 4.31267 14.5828 4.18769 14.3651C4.06256 14.1475 4 13.9119 4 13.6583V7.3417C4 7.08809 4.06256 6.8525 4.18769 6.63492C4.31267 6.41719 4.4857 6.24496 4.70678 6.11823L10.2932 2.89932C10.5143 2.77259 10.7499 2.70923 11 2.70923C11.2501 2.70923 11.4857 2.77259 11.7068 2.89932L17.2932 6.11823C17.5143 6.24496 17.6873 6.41719 17.8123 6.63492C17.9374 6.8525 18 7.08809 18 7.3417V13.6583C18 13.9119 17.9374 14.1475 17.8123 14.3651C17.6873 14.5828 17.5143 14.7551 17.2932 14.8818L11.7068 18.1007C11.4857 18.2274 11.2501 18.2908 11 18.2908C10.7499 18.2908 10.5143 18.2274 10.2932 18.1007ZM14.2476 8.11564L16.6219 6.74932L11.2693 3.65138C11.1794 3.59538 11.0897 3.56739 11 3.56739C10.9103 3.56739 10.8206 3.59538 10.7307 3.65138L8.6375 4.85451L14.2476 8.11564ZM11 9.99863L13.3625 8.62707L7.74063 5.37798L5.37813 6.74932L11 9.99863Z" fill="#242424"/></svg>';
          }
          jQuery('.cart__goal__message').html(tempStr);
          jQuery('.cc-cart-progress-heading .svg-html').html('');
          jQuery('.cc-cart-progress-heading .svg-html').html(svg);
        }
      }
});
 //}
}

// Call updateCartProgress only when needed, not continuously
// Listen for cart updates via Shopify's pub/sub system
if (typeof subscribe === 'function') {
  subscribe('cartUpdate', updateCartProgress);
}

// For initial load on cart page, run once
if (window.location.pathname.indexOf('/cart') !== -1) {
  updateCartProgress();
}

// For cart drawer, update when opened
jQuery(document).on('click', '#cart-icon-bubble, [href="/cart"]', function() {
  setTimeout(updateCartProgress, 100);
});
// END :: CART PROGRESS

function cartUpdateData(lineitemKey, selling_planid) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: jQuery.param({
      id: lineitemKey,
      quantity: 1,
      selling_plan: selling_planid
    }),
    dataType: "json",
    success: function (cart) {
      customdrawerOpen();
    },
    error: function (error) {
      console.log("Error upgrading subscription:", error.responseJSON || error);
    }
  });
}

// TEXT MARQUEE -- START
let SwiperTop = new Swiper('.text_marquee_slider', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 10000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true
});
// TEXT MARQUEE -- END

// BANNER REVIEWS -- START
$('.banner_review_grid').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 768,
        settings: "slick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
});
// BANNER REVIEWS -- END

// OUR PRODUCTS -- START
$('.our_product_col').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M22.8008 14.0001H5.20148M5.20148 14.0001L11.8012 7.40039M5.20148 14.0001L11.8012 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M5.19922 14.0001H22.7985M22.7985 14.0001L16.1988 7.40039M22.7985 14.0001L16.1988 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
});
// OUR PRODUCTS -- END

// VITAL SOCIETY -- START
$('.vital_society_slider').slick({
  centerMode: false,
  slidesToShow: 3,
  arrows: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M22.8008 14.0001H5.20148M5.20148 14.0001L11.8012 7.40039M5.20148 14.0001L11.8012 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M5.19922 14.0001H22.7985M22.7985 14.0001L16.1988 7.40039M22.7985 14.0001L16.1988 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  loop: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        dots: true,
        centerMode: true,
        centerPadding: '24px',
        slidesToShow: 1
      }
    }
  ]
});


$('.vital_society_slider_landing').slick({
  centerMode: false,
  slidesToShow: 4,
  arrows: true,
  dots: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M22.8008 14.0001H5.20148M5.20148 14.0001L11.8012 7.40039M5.20148 14.0001L11.8012 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M5.19922 14.0001H22.7985M22.7985 14.0001L16.1988 7.40039M22.7985 14.0001L16.1988 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  loop: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        centerMode: true,
        centerPadding: '24px',
        slidesToShow: 1
      }
    }
  ]
});

// VIdeo JS
$(document).ready(function () {
  var currentPlaying = null;

  $(".vital_society_inner").each(function () {
    var $wrapper = $(this);
    var $video = $wrapper.find("video");
    var $poster = $wrapper.find(".pcv_poster");
    var $playIcon = $wrapper.find(".pcv_play_icon");
    $playIcon.on("click", function () {
      if (currentPlaying && currentPlaying[0] !== $video[0]) {
        currentPlaying[0].pause();
        currentPlaying.closest(".vital_society_inner").find(".pcv_poster").show();
      }

      $poster.hide();
      $video.prop("muted", false);
      $video[0].play();

      currentPlaying = $video;
    });

    $video.on("pause ended", function () {
      $poster.show();
    });

    $video.on("click", function () {
      if (!$video[0].paused) {
        $video[0].pause();
        $poster.show();
      }
    });
  });
});


// VITAL SOCIETY -- END

// BANNER FAQ -- START
document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".banner_faq_item_header"
  );

  if (firstAccordionItemHeader) { // <-- check if it exists
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

    firstAccordionItemHeader.classList.add("active");
    firstAccordionItemBody.style.maxHeight = firstAccordionItemBody.scrollHeight + "px";

    const accordionItemHeaders = document.querySelectorAll(
      ".banner_faq_item_header"
    );

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".banner_faq_item_header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  }
});

// BANNER FAQ -- END

// PRODUCT SPOTLIGHT -- START
$('.product_spotlight_slider').slick({
  centerMode: false,
  slidesToShow: 1,
  arrows: true,
  dots: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M22.8008 14.0001H5.20148M5.20148 14.0001L11.8012 7.40039M5.20148 14.0001L11.8012 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M5.19922 14.0001H22.7985M22.7985 14.0001L16.1988 7.40039M22.7985 14.0001L16.1988 20.5999" stroke="#124734" stroke-width="1.5" stroke-linecap="square"/></svg></button>',
  loop: false
});
// PRODUCT SPOTLIGHT -- END

// PRODUCT ATC -- START
jQuery(document).on('change','.card_product_variant_select',function(e){
  e.preventDefault();
  if(jQuery(this).parent().find('.custom_loader_select').find('.loading__spinner').length>0){
    jQuery(this).parent().find('.custom_loader_select').find('.loading__spinner').removeClass('hidden');
    jQuery(this).parent().find('.custom_loader_select').addClass('active');
  }
  console.log("innnn")
  var variantId = jQuery(this).val();;
  var productId = jQuery(this).attr('data-pid');
  if(variantId != ''){
    addToCart(variantId,productId);
    $(this).val('');
  }
});
jQuery(document).on('click','.card_product_variant_btn',function(e){
  if(jQuery(this).find('.loading__spinner').length>0){
    jQuery(this).find('.loading__spinner').removeClass('hidden');
  }
  var variantId = jQuery(this).attr('data-vid');
  var productId = jQuery(this).attr('data-pid');
  if(variantId != ''){
    addToCart(variantId,productId);
  }
});

// PRODUCT ATC -- END


// PRODUCT DETAILS PAGE FOR ROUTINE SECTION ADD TO CART CODE START HERE
jQuery(document).on('click','.other_flavor .other_flavor-cart-icon.routine_add_Cart,.product__info-container .routine_product_btn.routine_add_Cart',function(e){
  if(jQuery(this).find('.loading__spinner').length>0){
    jQuery(this).find('.loading__spinner').removeClass('hidden');
  }
  var variantId = jQuery(this).attr('data-vid');
  var productId = jQuery(this).attr('data-pid');
  addToCart(variantId,productId);
});

function addToCart(variantId, productId) {
  if(variantId != ''){
    var formData = {
      items: [{ id: variantId, quantity: 1 }],
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify(formData),
      contentType: "application/json",
      dataType: "json",
      success: function (response) {
        customdrawerOpen(productId);
      }
    });
  }
}

jQuery(document).ready(function(){
  var upsellInter = setInterval(function(){
    if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0 || jQuery('.product__info-wrapper .routine_product_block').length>0){
      upsellProductHideShow();
    }
  },10);
});

jQuery(document).on('click','.drawer__cart-items-wrapper .cart-remove-button',function(){
  var quantity = jQuery(this).parent().parent().find('.quantity__input').attr('data-cart-quantity');
  var productId = jQuery(this).attr('data-pcart-id');
  setTimeout(function(){
    if(jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productId+'"]').length>0){
      jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productId+'"]').show();
    }
    upsellProductHideShow();
  },1000);
});

function customdrawerOpen(productid=''){
  if(jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productid+'"]').length>0){
    jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productid+'"]').hide();
  }
  if(jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productid+'"]').length>0){
    jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productid+'"]').hide();
  }
  
  upsellProductHideShow();
  var cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
    $.ajax({
      url: "/?sections=cart-drawer,cart-icon-bubble",
      type: "GET",
      dataType: "json",
      success: function (parsedState) {
        if (!parsedState || !parsedState["cart-drawer"]) {
          console.error("Error: cart-drawer section not found", parsedState);
          return;
        }
        cartDrawer.renderContents({
          sections: {
            "cart-drawer": parsedState["cart-drawer"],
            "cart-icon-bubble": parsedState["cart-icon-bubble"],
          },
        });
        if(jQuery('.loading__spinner').length>0){
          jQuery('.loading__spinner').addClass('hidden');
        }
        if(jQuery('.custom_loader_select').length>0){
          jQuery('.custom_loader_select').removeClass('active');
        }
      }
    });
  }
  else{
    if(jQuery('.loading__spinner').length>0){
      jQuery('.loading__spinner').addClass('hidden');
    }
    if(jQuery('.custom_loader_select').length>0){
      jQuery('.custom_loader_select').removeClass('active');
    }
  }
}

function upsellProductHideShow(){
  if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0){
    var totalUpsellCount = parseInt(jQuery('#drawer_product_count').val());
    var totalUpsellVisibleCount = 0;
    jQuery('.cart-drawer .other_flavor').find('.other_flavor-card').each(function() {
      if(jQuery(this).css('display')=='none'){
         totalUpsellVisibleCount++;
      }
    });
    //console.log("totalUpsellCount",totalUpsellCount);
    //console.log("totalUpsellVisibleCount",totalUpsellVisibleCount);
    if(totalUpsellCount==totalUpsellVisibleCount){
      jQuery('.cart-drawer').find('.other_flavor').hide();
    }else{
      jQuery('.cart-drawer').find('.other_flavor').show();
    }
  }
  if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0 && jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col').length>0){
    var totalUpsellCount = parseInt(jQuery('#collect_product_count').val());
    var totalUpsellVisibleCount = 0;
    jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col').each(function() {
      if(jQuery(this).css('display')=='none'){
         totalUpsellVisibleCount++;
      }
    });
    if(totalUpsellCount==totalUpsellVisibleCount){
      jQuery('.product__info-wrapper .routine_product_block').hide();
    }else{
      jQuery('.product__info-wrapper .routine_product_block').show();
    }
  }
}
// PRODUCT DETAILS PAGE FOR ROUTINE SECTION ADD TO CART CODE END HERE


// PRODUCT DETAILS PAGE FOR VARIANT WISE PRICE CHANGE FOR SUBSCIRPTION SELECTED START JS
jQuery(document).on("click", ".product__info-wrapper", function(e) {
  setTimeout(function() {
    if (
      jQuery(".product__info-wrapper").find('[name="selling_plan"]').length > 0 
    ) {
      var getval = jQuery(".product__info-wrapper").find('[name="selling_plan"]').val();
      //console.log("getvall",getval);
      if(getval==""){
        subscriptionPriceMain();
      }else{
        subscriptionPriceMain(1);
      }
    }
  }, 900);
});
function getRechargePrices(variantId) {
  if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {
    let prices = window.SubscriptionWidgetConfig.formattedPrices[variantId];
    if (prices) {
      //console.log("Prices for variant", variantId, prices);
      //console.log("Prices for variant", variantId, prices);
      let oneTimePrice = prices.onetime;
      let subscriptionPrices = {};
      Object.keys(prices).forEach(function (key) {
        if (key !== "onetime") {
          subscriptionPrices[key] = prices[key];
        }
      });
      //console.log("One-time:", oneTimePrice);
      //console.log("Subscriptions:", subscriptionPrices);
      return {prices};
    } else {
      console.warn("No prices found for variant:", variantId);
    }
  } else {
    console.error("SubscriptionWidgetConfig not found");
  }
  return null;
}

jQuery(document).ready(function(){
  var subscribeId = setInterval(function(){
    if(jQuery('.product__info-wrapper').find('.shopify-app-block.recharge-subscription-widget').length>0){
      subscriptionPriceMain(1);
      clearInterval(subscribeId);
    }
  },200);
})

function subscriptionPriceMain(flag=""){
  if(jQuery('.product__info-wrapper').find('.shopify-app-block.recharge-subscription-widget').length>0){
    if(jQuery('.product_buybutton_block').find('[name="id"]').length>0){
      var variantId = jQuery('.product_buybutton_block').find('[name="id"]').val();
      if(variantId) {
        var getVariantPrice = getRechargePrices(variantId);
        var comparePrice = getVariantPrice.prices.unit;
        var mainPrice = getVariantPrice.prices.discounted;

        //console.log("Default Selected Selling Plan:", comparePrice,mainPrice);
        //console.log(flag);
        if(flag==""){
          mainPrice = comparePrice;
          if(jQuery('.product__info-wrapper').find('.variant_bundle_pricebox').find('.variant__cprice').length>0){
            var activePack = jQuery('.product__info-wrapper').find('.product_variant_block').find('.option-pack-class:checked').attr('data-pack');
            var comparePrice = jQuery('.product__info-wrapper').find('.product_variant_block').find('.product_variant_label[data-pack="'+activePack+'"]').find('.variant__cprice').text();
            //console.log("comparePrice",comparePrice);
          }
        }
        if(jQuery('.product__info-wrapper').find('.price-item.price-item--regular').length>0){
          jQuery('.product__info-wrapper').find('.price-item.price-item--regular').text('');
          jQuery('.product__info-wrapper').find('.price-item.price-item--regular').text(comparePrice);
        }
        if(jQuery('.product__info-wrapper').find('.price-item.price-item--sale').length>0){
          jQuery('.product__info-wrapper').find('.price-item.price-item--sale').text(mainPrice);
        }
      }
    }
  }
}
// PRODUCT DETAILS PAGE FOR VARIANT WISE PRICE CHANGE FOR SUBSCIRPTION SELECTED END JS


//:: START :: LANDING FAQ :: ==================

$(document).ready(function () {
  $("ul.benefits_tabing li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.benefits_tabing li").removeClass("current");
    $(".benefits_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});

$(document).ready(function () {
  $(".landing_benefit_tabbing .lb-section-tabbing ul li").click(function () {
    var tab_id = $(this).attr("data-tab");
    console.log("ta ",tab_id);
    $(".landing_benefit_tabbing .lb-section-tabbing ul li").removeClass("current");
    $(".landing_benefit-text-tabbox").removeClass("current");

    $(this).addClass("current");
    if($("#" + tab_id).find('.benefits_tabing').find('.tab-link.current').length==0){
      $("#" + tab_id).find('.benefits_tabing').find('.tab-link').eq(0).addClass('current');
      $("#" + tab_id).find('.benefits_tab_content').eq(0).addClass('current');
    }
    $("#" + tab_id).addClass("current");
  });
});

$(document).ready(function () {
    $(".benefits_box").click(function () {
        var accordion_id = $(this).attr("data-accordion");
        console.log("accordion ", accordion_id);
        
        var isCurrentlyOpen = $(this).hasClass("current");
        
        // Remove current class from all benefits boxes
        $(".benefits_box").removeClass("current");
        
        // Add current class to clicked item if it wasn't open
        if (!isCurrentlyOpen) {
            $(this).addClass("current");
        }
    });
});
//:: END :: LANDING FAQ :: ==================


// STICKT CTA CLASS ADD -- START
window.addEventListener("scroll", function () {
  const target = document.querySelector(".offerbar-section.landing_sticky_cta");
  const featureSection = document.querySelector(".feature-product-section .bundle-variant-form");
  const blackFridaySection = document.querySelector(".black-friday-section .cta-button");

  if (!target) return;

  const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

  let featureVisible = false;
  if (featureSection) {
    const rect = featureSection.getBoundingClientRect();
    featureVisible = rect.top < window.innerHeight && rect.bottom > 0;
  }

  let blackFridayVisible = false;
  if (blackFridaySection) {
    const rect2 = blackFridaySection.getBoundingClientRect();
    blackFridayVisible = rect2.top < window.innerHeight && rect2.bottom > 0;
  }

  if (scrollPercent >= 15 && !featureVisible && !blackFridayVisible) {
    target.classList.add("is_sticky");
  } else {
    target.classList.remove("is_sticky");
  }
});
// STICKT CTA CLASS ADD -- END